export const PRIORITY_FIELD = 'priority';
export const EMPTY_STRING = '';
export const DASH = '-';
export const ADD = '+';
export const ALL = 'ALL';
// format constants
export const TWO_DECIMALS_FORMAT = '.2-2';
